import {makeDispatchClosureItems} from "../helpers/dispatch-closure-items.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";

export default function DispatchClosure({ title, data }) {
    const closure = makeDispatchClosureItems(data);
    const observation = data?.dispatch?.dispatch_finalobservation ?? "";

    return (
        <>
            <InfoGrid title={title} items={closure} />
            <div className="px-5 mt-8">
                <ObservationBox title="Observação final">
                    {observation}
                </ObservationBox>
            </div>
        </>
    )
}